<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <!-- 门店 -->
          <el-form-item label="门店" prop="branchId">
            <el-select
              v-model="form.branchId"
              placeholder="请选择门店"
              class="fix-width"
              clearable
              @change="branchChange"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务器地址" prop="url">
            <el-input v-model.trim="form.url" />
          </el-form-item>
          <el-form-item label="key" prop="key">
            <el-input v-model.trim="form.key" show-password />
          </el-form-item>
          <el-form-item label="酒店编码" prop="hotelCode">
            <el-input v-model.trim="form.hotelCode" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getBangWeiConfig, setupBangWei } from '@/api/settings'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'SettingsBangWei',
  data() {
    return {
      labelPosition: 'right',
      branchList: [],
      form: {
        branchId: '',
        url: '',
        key: '',
        hotelCode: '',
      },
      rules: {
        branchId: [],
        url: [],
        key: [],
        hotelCode: [],
      },
    }
  },
  mounted() {
    this.getData()
    this.getAllBranchs()
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    async getData(branchId) {
      const ret = await getBangWeiConfig({
        branchId: branchId || ''
      })
      const { url = '', key = '', hotelCode = '' } = ret && ret.basic || {}
      this.form = {
        branchId,
        url,
        key,
        hotelCode
      }
    },
    branchChange(branchId) {
      this.getData(branchId)
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.form)
          const branchId = form.branchId
          delete form.branchId
          await setupBangWei({
            config: this.form,
            branchId
          })
          this.getData(branchId)
          this.$message.success('保存邦威客控配置成功')
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  padding-bottom: 10px;
  border-bottom: 1px solid #e3e3e3;
}
</style>
